import React, { Component } from 'react'
import PropTypes from 'prop-types'
import StyleSheet from 'styles'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Chip from '@material-ui/core/Chip'
import m from 'moment'
import { humanize } from 'utils'
import { ImageAvatar } from 'components'

export class DealSheetBanner extends Component {

  static propTypes = {
    dealSheet: PropTypes.object.isRequired
  }

  static defaultProps = {
  }

  renderAvatar = ({ issuerAccountName , logoFileName, logoUrls }=this.props.dealSheet) => {
    return <ImageAvatar alt={ issuerAccountName } urls={ logoUrls } className={styles.avatar}/>
  }

  renderStartsAtBox = () =>{
    const diff = m().diff(m(this.props.dealSheet.startDate))
    const startsAt = diff < 0 ?
      `Starts ${m(this.props.dealSheet.startDate).format('MMM Do')}. Opens in ${m.duration(diff).humanize()}` :
      `Started ${m(this.props.dealSheet.startDate).format('MMM Do YYYY')}`
    return <Typography variant='body1' style={{color: '#10F8B9', display: 'inline-block'}}>{startsAt}</Typography>
  }

  render() {
    return (
      <AppBar position="static" color='inherit'>
        <Toolbar className={styles.toolbar}>
          <div className={styles.headerAndAvatar}>
            {this.renderAvatar()}
            <div className={styles.dealSheetHeading}>
              <div style={{display: 'inline-block', verticalAlign: 'middle', marginRight: 15}}>
                <Typography variant='body1' style={{marginBottom: -10}}>{this.props.dealSheet.tagLine}</Typography>
                <Typography><a href={this.props.dealSheet.tokenSaleWebsite}>{this.props.dealSheet.tokenSaleWebsite}</a></Typography>
              </div>
              <Chip className={styles.statusChip} label={humanize(this.props.dealSheet.status)}/>
              {this.renderStartsAtBox()}
            </div>
          </div>
        </Toolbar>
      </AppBar>
    )
  }
}

const styles = StyleSheet({
  avatar: {
    marginTop: 18,
  },
  statusChip: {
    display: 'inline-flex',
    marginRight: 15,
    backgroundColor: 'rgba(200, 18, 236, 0.5)'
  },
  headerAndAvatar: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row'
  },
  dealSheetHeading: {
    flex: 1,
    margin: 15,
    '& h6 ': {
      marginTop: 10
    }
  },
  '@media(max-width: 800px)': {
    toolbar: {
      flexDirection: 'column',
      alignItems: 'baseline'
    },
    dealSheetStartsAt: {
      '& h5': {
        alignText: 'left',
        fontSize: 13
      }
    }
  },
})

export default DealSheetBanner